var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-actions"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.deleteDescriptions}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}}),_vm._v(" Dzēst uz dzēšanu atzīmētos aprakstus")])])}
var staticRenderFns = []

export { render, staticRenderFns }